import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function getAssinaturas (dados) {
  return sessaoFetchLoading(`consig`, `/assinaturas/StatusAssinaturas`, 'PATCH', dados)
}
export async function getTotalizadores (dados) {
  return sessaoFetchLoading(`consig`, `/assinaturas/TotalizadoresStatusAssinaturas?` + serialize(dados), 'GET')
}
export async function getLiberado (dados) {
  return sessaoFetchLoading(`consig`, `/assinaturas/GerarTotalizadorComissoesLiberadasStatusAssinaturas?` + serialize(dados), 'GET')
}



// WEBPACK FOOTER //
// ./src/api/statusassinatura.js